/**
 * - Added `AccountBreadcrumbs` to the `first` slot
 */

import { Layout } from '@/data/types/Layout';

export const getCreateCheckoutProfilePage = (): Layout => ({
	name: 'Aside',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'AccountBreadcrumbs', id: 'account-breadcrumbs' }],
		aside: [{ name: 'AccountSidebar', id: 'account-sidebar' }],
		second: [{ name: 'CreateCheckoutProfile', id: 'create-checkout-profile' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
